<script setup lang="ts">
import { Tag } from '@collector/shared-ui'

import { IncidentFilterToggle } from './types'
import { getIncidentFilterName } from './utils'

interface Props {
  incidentFilter: IncidentFilterToggle
}

defineProps<Props>()

// emits
defineEmits(['delete'])
</script>

<template>
  <Tag
    v-if="incidentFilter.value"
    @delete="$emit('delete')"
  >
    <span class="capitalize">
      {{ getIncidentFilterName(incidentFilter) }}
    </span>
  </Tag>
</template>
